import React, { useState, useEffect } from 'react';
import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '';

const Admin: React.FC = () => {
  const [articles, setArticles] = useState([]);
  const [title, setTitle] = useState('');
  const [content, setContent] = useState('');
  const [image, setImage] = useState<File | null>(null);

  useEffect(() => {
    fetchArticles();
  }, []);

  const fetchArticles = async () => {
    const response = await axios.get(`${API_BASE_URL}/api/articles`);
    setArticles(response.data);
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append('title', title);
    formData.append('content', content);
    if (image) formData.append('image', image);

    await axios.post(`${API_BASE_URL}/api/articles`, formData);
    fetchArticles();
    setTitle('');
    setContent('');
    setImage(null);
  };

  return (
    <div>
      <h1>Admin Panel</h1>
      <form onSubmit={handleSubmit}>
        <input
          type="text"
          placeholder="Title"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          required
        />
        <textarea
          placeholder="Content"
          value={content}
          onChange={(e) => setContent(e.target.value)}
          required
        />
        <input
          type="file"
          onChange={(e) => setImage(e.target.files ? e.target.files[0] : null)}
        />
        <button type="submit">Add Article</button>
      </form>
      <ul>
        {articles.map((article: any) => (
          <li key={article.id}>
            <h3>{article.title}</h3>
            <p>{article.content}</p>
            {article.image && <img src={`${API_BASE_URL}/uploads/${article.image}`} alt="Article" />}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Admin;